<template>
  <div></div>
</template>

<script >
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "interactive-chapters",
  props: {
    player: {
      required: true,
      type: Object,
    },
  },
  computed: {
    Chapters() {
      const interactivityOptions = this.setVideoInfos?.interactivityOptions;
      if (interactivityOptions && interactivityOptions.data) {
        return interactivityOptions.data.interactivity?.filter((inter) => inter.type === "chapter") || [];
      }
      return [];
    },
    ...mapGetters(['getCurrentTime', 'setVideoInfos'])
  },

  data() {
    return {
      itemToDisplay: {},
      timeCurrent: -1,
    };
  },
  watch: {
    player: {
      handler() {
        this.player.on("loadedmetadata", () => {
          const customMarkers = document.querySelectorAll(".vjs-custom-chap-marker");
          customMarkers.forEach((marker) => {
            marker?.parentNode?.removeChild(marker);
          });
          this.Chapters?.forEach((item) => {
            const markerItem =
              this.player.controlBar?.progressControl.seekBar.addChild("button");
            markerItem?.controlText(item.title);
            const customMarkerElement = markerItem?.el();
            customMarkerElement?.classList.add("vjs-custom-chap-marker");
            if (this.player.duration() > 0) {
              if(item.start===Math.floor(this.player.duration())){
                customMarkerElement.style.left =
                (item.start * 100) / Math.floor(this.player.duration()) + "%";

              }else{
                customMarkerElement.style.left =
                (item.start * 100) / this.player.duration() + "%";

              }            }
          });
        });
        this.player.on("timeupdate", () => {
          const currentTime = Math.floor(this.player.currentTime());
          this.Chapters?.forEach((item) => {
            if (
              this.player.hasStarted_ &&
              item.start === currentTime &&
              item.start != this.timeCurrent
              && item.start
            ) {
              this.timeCurrent = item.start;
              this.itemToDisplay = item;
            }
          });
        });
      },
      deep: true,
    },
  },
});
</script>

<style>
.video-js.vjs-custom-skin .vjs-custom-chap-marker {
  cursor: pointer;
  background: var(--vm-color-one-08);
  width: 0.6em;
  height: 0.6em;
  position: absolute;
  border-radius: 4px;
  top: -1px;
  z-index: 1;
  border: 1px solid;
}
</style>
